import {Card, Col, Row} from "antd";
import {toFSDate} from "../../util/timeutils";

export const BasicBatchInfo = ({batch, roomMap}) => {
    const rowStyle = {
        margin: '10px'
    }

    const cardStyle = {textAlign: 'left', margin: "5px"}

    const {name, description, created, startTime, harvestTime, flowerRoomId, harvestRoomId} = batch;

    const creationTime = (created) ? toFSDate(new Date(created)) : 'None';
    const batchStartTime = (startTime) ? toFSDate(new Date(startTime)) : 'None';
    const batchHarvestTime = (harvestTime) ? toFSDate(new Date(harvestTime)) : 'None';
    const flowerRoom = (flowerRoomId) ? roomMap[flowerRoomId].name : 'None';
    const harvestRoom = (harvestRoomId) ? roomMap[harvestRoomId].name : 'None';

    return <Card style={cardStyle} title={<b>{batch.name}</b>}>
        <Row style={rowStyle}>
            <Col span={3}><b>Name:</b></Col>
            <Col>{name}</Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={3}><b>Description:</b></Col>
            <Col span={8}>
                {description}
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={3}><b>Created:</b></Col>
            <Col>{creationTime}</Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={3}><b>Start Time:</b></Col>
            <Col>{batchStartTime}</Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={3}><b>Harvest Time:</b></Col>
            <Col>{batchHarvestTime}</Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={3}><b>Flower Room:</b></Col>
            <Col>{flowerRoom}</Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={3}><b>Harvest Room:</b></Col>
            <Col>{harvestRoom}</Col>
        </Row>
    </Card>
}